import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Section, SectionHead } from "@/components/common";
import { NewsCard } from "@/pages/Home";

const TOPICS = [
  ["power", "Power"], ["water", "Water"], ["cooling", "Cooling"], ["jobs", "Jobs"],
  ["taxRevenue", "Tax"], ["emissions", "Emissions"], ["noise", "Noise"],
  ["community", "Community"], ["policy", "Policy"], ["international", "International"],
];

export default function Newsroom() {
  const [news, setNews] = useState([]);
  const [status, setStatus] = useState(null);
  const [topic, setTopic] = useState("");

  useEffect(() => {
    api.get(`/news${topic ? `?topic=${topic}` : ""}`).then((r) => setNews(r.data));
    api.get("/news/status").then((r) => setStatus(r.data));
  }, [topic]);

  const fmt = (iso) => iso ? new Date(iso).toLocaleString() : "—";

  return (
    <Section className="py-12 sm:py-16">
      <SectionHead eyebrow="Newsroom" title="Sourced data center news"
        desc="Routine sourced summaries are published automatically; major allegations and high-impact stories go to an editor for review first. Every item links to its original source." />

      {status && (
        <div className="card p-4 mb-6 flex flex-wrap gap-x-8 gap-y-1 text-sm">
          <span className="text-slate-400">Last checked: <span className="text-white font-mono">{fmt(status.last_checked)}</span></span>
          <span className="text-slate-400">Last successful update: <span className="text-[#84CC16] font-mono">{fmt(status.last_success)}</span></span>
          <span className="text-slate-400">Published items: <span className="text-white font-mono">{status.published_count}</span></span>
        </div>
      )}

      <div className="flex flex-wrap gap-2 mb-6">
        <button data-testid="topic-filter-all" onClick={() => setTopic("")} className={`text-sm px-4 py-2 rounded-lg border transition-colors ${!topic ? "bg-[#2563EB] border-[#2563EB] text-white" : "border-white/10 text-slate-300 hover:border-blue-500/50"}`}>All</button>
        {TOPICS.map(([val, label]) => (
          <button key={val} data-testid={`topic-filter-${val}`} onClick={() => setTopic(val)}
            className={`text-sm px-4 py-2 rounded-lg border transition-colors ${topic === val ? "bg-[#2563EB] border-[#2563EB] text-white" : "border-white/10 text-slate-300 hover:border-blue-500/50"}`}>{label}</button>
        ))}
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        {news.length === 0 && <div className="card p-8 text-slate-400 text-sm md:col-span-2 text-center">No briefings yet for this filter. The crawler checks approved sources every 3 hours.</div>}
        {news.map((n) => <NewsCard key={n.id} n={n} />)}
      </div>
    </Section>
  );
}
